import React from "react";
import Logo from "../Assets/logo.png";
import DropDown from "../Components/DropDown";
import SignUpImg from "../Assets/SignUpImg.png";
import { Link } from "react-router-dom";
import AiTeamDropDown from "../Components/AiTeamDropDown";

export default function SignUp() {
  return (
    <div className="flex items-center">
      <div className="w-[50%]">
        <div className="flex items-center justify-center h-[100vh]">
          <div className="w-[32rem]">
            <img className="w-[7.6rem] h-[2.25]" src={Logo} />
            <div className="flex flex-col gap-1 mt-5">
              <h2 className="text-[1.2rem] font-[800] text-[#111928]">
                Create your account
              </h2>
              <p className="text-[1rem] text-[#6B7280]">
                Provide Your Details to Access AI People Ecosystem
              </p>
            </div>
            <div>
              <form>
                <div className="mt-5">
                  <div className="flex items-start flex-col gap-1">
                    <label className="text-[0.95rem] text-[#111928] font-[500]">
                      Email
                    </label>
                    <input
                      className="w-full h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                      type="email"
                      placeholder="email@email.com"
                    />
                  </div>
                  <div className="flex items-center justify-between mt-5">
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        First Name
                      </label>
                      <input
                        className="w-[15.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="text"
                        placeholder="e.g. Bonnie"
                      />
                    </div>
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Last Name
                      </label>
                      <input
                        className="w-[15.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="text"
                        placeholder="e.g. Green"
                      />
                    </div>
                  </div>
                  <div className="flex items-start flex-col gap-1 mt-5">
                    <label className="text-[0.95rem] text-[#111928] font-[500]">
                      Organization
                    </label>
                    <input
                      className="w-full h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                      type="text"
                      placeholder="Organization Name"
                    />
                  </div>
                  <div className="flex items-center justify-between mt-5">
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Your Role
                      </label>
                      <AiTeamDropDown
                        text="Select"
                        width="15.6rem"
                        options={[
                          "Data Scientist",
                          "Full Stack Developer",
                          "Machine Learning Engineer",
                          "Data Engineer",
                          "Decision Scientist",
                          "Front End Developer",
                          "Back End Developer",
                          "AI Translator",
                          "Business Stakeholder",
                          "Domain Expert",
                          "Product Manager",
                          "Project Manager",
                          "AI Architect",
                          "Manager",
                          "Leadership",
                          "Executive Sponsor",
                          "DevOps Expert",
                          "Database Administrator",
                          "AI Specialist/Research Scientist",
                          "Data Analyst",
                          "Business Intelligence Analyst",
                          "Data Visualization Expert",
                          "Statistician",
                          "Data Governance",
                          "Quality Officer",
                          "UI/UX Designer",
                          "Other           ",
                        ].sort()}
                      />
                    </div>
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Team Name
                      </label>
                      <AiTeamDropDown
                        text="Team Name 1"
                        width="15.6rem"
                        options={[
                          "Team Name 1",
                          "Team Name 2",
                          "Team Name 3",
                          "Team Name 4",
                          "Other"
                        ]}
                      />
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-5">
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Password
                      </label>
                      <input
                        className="w-[15.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="password"
                        placeholder="••••••••••"
                      />
                    </div>
                    <div className="flex items-start flex-col gap-1">
                      <label className="text-[0.95rem] text-[#111928] font-[500]">
                        Confirm your Password
                      </label>
                      <input
                        className="w-[15.6rem] h-[2.6rem] border-[1px] border-[#D1D5DB] bg-[#F9FAFB] text-[0.90rem] text-[#6B7280] pl-3 outline-none rounded-[8px]"
                        type="password"
                        placeholder="••••••••••"
                      />
                    </div>
                  </div>
                  <div className="mt-6">
                    <Link to="/check-email">
                      <button className="w-full h-[2.5rem] bg-[#942A27] rounded-[8px] text-[0.95rem] text-white font-[500]">
                        Sign Up
                      </button>
                    </Link>
                  </div>
                  <div>
                    <p className="text-[0.95rem] text-[#6B7280] mt-5">
                      Already have an account?{" "}
                      <span className="text-[#942A27]">Login here</span>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundImage: `url(${SignUpImg})`,
          backgroundSize: "100% 100%",
        }}
        className="w-[50%] h-[100vh] bg-no-repeat"
      ></div>
    </div>
  );
}
